module.exports = require("lodash/chunk");


//////////////////
// WEBPACK FOOTER
// external "lodash/chunk"
// module id = 64
// module chunks = 0